import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoButtonGroupComponent } from './go-button-group.component';

@NgModule({
  declarations: [GoButtonGroupComponent],
  imports: [
    CommonModule
  ],
  exports: [GoButtonGroupComponent]
})

export class GoButtonGroupModule { }
